module.exports = __webpack_public_path__ + "assets/angle-arrow-down.e7c95d5d.svg";